import Footer from "../footer/Footer";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Card from "./Card";
import board from "../../assets/board.png";
import membership from "../../assets/membership-card.jpg";

import "./Pages.css";
const About = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="about">
        <Helmet>
          <title>Esnad e.V | About | Über uns</title>
        </Helmet>
        <div className="about-card">
          <table>
            <tr>
              <td>
                <Link to={"board"} style={{ textDecoration: "none" }}>
                  <img
                    class="rel"
                    width={115}
                    height={110}
                    src={board}
                    alt="ESNAD e.V"
                  />
                </Link>
              </td>
              <td>
                <Link to={"membership"} style={{ textDecoration: "none" }}>
                <img
                    class="rel"
                    width={160}
                    height={160}
                    src={membership}
                    alt="ESNAD e.V"
                  />
                </Link>
              </td>
            </tr>
            <tr>
              <td>
                <Link to={"board"} style={{ textDecoration: "none" , color: "black"}}>
                {t("Board")}
                </Link>
              </td>
              <td>
                <Link to={"membership"} style={{color:"black", textDecoration:"none"}}>
                  {t("Membership")}
                </Link>
              </td>
            </tr>
          </table>
        </div>
        {/*<Card key={0} text={t("Board")} to={"board"} index={0} isFile={false} />
          <Card key={1} text={t("Constitution")} to={"constitution"} index={1}  isFile={false}/>
          <Card key={2} text={t("Membership")} to={"membership"} index={2} isFile={true} />*/}
        <Trans
          i18nKey="About-Text"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />,
            text: <text />
          }}
        />
        <Trans
          i18nKey="Vision"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />
          }}
        />
        <Trans
          i18nKey="Mission"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />
          }}
        />
        <Trans
          i18nKey="Principles"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />
          }}
        />
        <Trans
          i18nKey="Purpose-Goal"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />
          }}
        />
        <Trans
          i18nKey="Structure"
          components={{
            p: <p />,
            pre: <pre />,
            h4: <h4 />,
            ul: <ul />,
            li: <li />,
            strong: <strong />,
            h5: <h5 />
          }}
        />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default About;
